import * as React from "react"
import { QueryClient, QueryClientProvider, useQuery } from '@tanstack/react-query'
import DepQry from './App'

const queryClient = new QueryClient()



export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
<DepQry />
    </QueryClientProvider>
  )
}
